import Dropdown from 'react-bootstrap/Dropdown';
import './NavbarStyles.css';
import { FaClipboardList, FaBookOpen } from 'react-icons/fa';
import { BsPencil } from 'react-icons/bs';
import { MdSyncProblem } from 'react-icons/md';
import { RiFileList3Line } from 'react-icons/ri';
import { TbTrafficCone } from 'react-icons/tb';
import { VscTools } from 'react-icons/vsc';

const SFNavbar = () => {
	return (
		<nav>
			<ul class="vert-nav">
				<Dropdown drop={'end'}>
					<Dropdown.Toggle>Safety</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item href="/smart-finish/safety/safety-overview">Safety Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/safety/control-safety">Control Safety</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/safety/robot-safety">Robot Safety</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/safety/safety-devices">Safety Devices</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/safety/equipment-lockout">Equipment Lockout</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/safety/energy-sources">Energy Sources</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/safety/msds-info">MSDS Information</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle>Maintenance</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item href="/smart-finish/maintenance/maintenance-overview">Maintenance Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/maintenance/maintenance-safety">Maintenance Safety</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/maintenance/preventive-maintenance">Preventive Maintenance</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/maintenance/maintenance-lockout">Maintenance Lockout Procedure</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/maintenance/oem-maintenance">OEM Maintenance</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle>Troubleshooting</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item href="/smart-finish/troubleshooting/troubleshoot-overview">Troubleshooting Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/troubleshooting/mechanical-troubleshooting">Mechanical Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/troubleshooting/pneumatic-troubleshooting">Pneumatic Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/troubleshooting/electrical-troubleshooting">Electrical Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-finish/troubleshooting/oem-troubleshooting">OEM Troubleshooting</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle>Spare Parts</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item href="#/action-1">Action</Dropdown.Item>
						<Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
						<Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle>Appendix</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item href="#/action-1">Action</Dropdown.Item>
						<Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
						<Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</ul>
		</nav>
	);
};

const SINavbar = (props) => {
	return (
		<nav>
			<ul class="vert-nav">
				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="safety-element">
						<TbTrafficCone size={'4vw'} />
						<p>Safety</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/warren/safety/safety-overview">Safety Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/safety/control-safety">Control Safety</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/safety/safety-devices">Safety Devices</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/safety/equipment-lockout">Equipment Lockout</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/safety/energy-sources">Energy Sources</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="equipment-element">
						<FaClipboardList size={'4vw'} />
						<p>Equipment</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/warren/equipment/equipment-overview">Equipment Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/equipment/assemblies">Assemblies</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/equipment/electrical-panels">Electrical Panels</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/equipment/system-control">System Control</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/equipment/part-detect">Part / Skid Detect</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="maintenance-element">
						<VscTools size={'4vw'} />
						<p>Maintenance</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/warren/maintenance/maintenance-overview">Maintenance Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/maintenance/maintenance-safety">Maintenance Safety</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/maintenance/maintenance-lockout">Maintenance Lockout Procedure</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/maintenance/preventive-maintenance">Preventive Maintenance</Dropdown.Item>

						{/* <Dropdown.Item href="/smart-inspect/warren/maintenance/oem-maintenance">OEM Maintenance</Dropdown.Item> */}
						<Dropdown.Item href="/smart-inspect/warren/maintenance/maintenance-procedures">Maintenance Procedures</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/maintenance/machine-ledgers">Machine Ledgers</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="troubleshooting-element">
						<MdSyncProblem size={'4vw'} />
						<p>Troubleshoot</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/warren/troubleshooting/troubleshoot-overview">Troubleshooting Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/troubleshooting/mechanical-troubleshooting">Mechanical Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/troubleshooting/electrical-troubleshooting">Electrical Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/troubleshooting/oem-troubleshooting">OEM Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/troubleshooting/smart-inspect-troubleshooting">SMARTInspect Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/warren/troubleshooting/hardware-troubleshooting">Hardware Troubleshooting</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="drawing-element" href="/smart-inspect/warren/drawings">
						<BsPencil size={'4vw'} />
						<p>Drawings</p>
					</Dropdown.Toggle>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="appendix-element">
						<FaBookOpen size={'4vw'} />
						<p>Appendix</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/warren/appendix">Appendix</Dropdown.Item>
						{/* <Dropdown.Item href="/smart-inspect/warren/training-docs">Training Docs</Dropdown.Item> */}
					</Dropdown.Menu>
				</Dropdown>
			</ul>
		</nav>
	);
};
const MMANavbar = (props) => {
	return (
		<nav>
			<ul class="vert-nav">
				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="safety-element">
						<TbTrafficCone size={'4vw'} />
						<p>Safety</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/montgomery/safety/safety-overview">Safety Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/safety/control-safety">Control Safety</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/safety/safety-devices">Safety Devices</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/safety/equipment-lockout">Equipment Lockout</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/safety/energy-sources">Energy Sources</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="equipment-element">
						<FaClipboardList size={'4vw'} />
						<p>Equipment</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/montgomery/equipment/equipment-overview">Equipment Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/equipment/assemblies">Assemblies</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/equipment/electrical-panels">Electrical Panels</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/equipment/system-control">System Control</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/equipment/part-detect">Part / Skid Detect</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="maintenance-element">
						<VscTools size={'4vw'} />
						<p>Maintenance</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/montgomery/maintenance/maintenance-overview">Maintenance Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/maintenance/maintenance-safety">Maintenance Safety</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/maintenance/maintenance-lockout">Maintenance Lockout Procedure</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/maintenance/preventive-maintenance">Preventive Maintenance</Dropdown.Item>

						<Dropdown.Item href="/smart-inspect/montgomery/maintenance/oem-maintenance">OEM Maintenance</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/maintenance/maintenance-procedures">Maintenance Procedures</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/maintenance/machine-ledgers">Machine Ledgers</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="troubleshooting-element">
						<MdSyncProblem size={'4vw'} />
						<p>Troubleshoot</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/montgomery/troubleshooting/troubleshoot-overview">Troubleshooting Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/troubleshooting/mechanical-troubleshooting">Mechanical Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/troubleshooting/electrical-troubleshooting">Electrical Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/troubleshooting/oem-troubleshooting">OEM Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/troubleshooting/smart-inspect-troubleshooting">SMARTInspect Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/montgomery/troubleshooting/hardware-troubleshooting">Hardware Troubleshooting</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="drawing-element" href="/smart-inspect/montgomery/drawings">
						<BsPencil size={'4vw'} />
						<p>Drawings</p>
					</Dropdown.Toggle>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="appendix-element">
						<FaBookOpen size={'4vw'} />
						<p>Appendix</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/montgomery/appendix">Appendix</Dropdown.Item>
						<Dropdown.Item>Training Docs</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</ul>
		</nav>
	);
};

const FWNavbar = (props) => {
	return (
		<nav>
			<ul class="vert-nav">
				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="safety-element">
						<TbTrafficCone size={'4vw'} />
						<p>Safety</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/fort-wayne/safety/safety-overview">Safety Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/safety/control-safety">Control Safety</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/safety/safety-devices">Safety Devices</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/safety/equipment-lockout">Equipment Lockout</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/safety/energy-sources">Energy Sources</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="equipment-element">
						<FaClipboardList size={'4vw'} />
						<p>Equipment</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/fort-wayne/equipment/equipment-overview">Equipment Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/equipment/assemblies">Assemblies</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/equipment/electrical-panels">Electrical Panels</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/equipment/system-control">System Control</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/equipment/part-detect">Part / Skid Detect</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="maintenance-element">
						<VscTools size={'4vw'} />
						<p>Maintenance</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/maintenance-overview">Maintenance Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/maintenance-safety">Maintenance Safety</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/maintenance-lockout">Maintenance Lockout Procedure</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/preventive-maintenance">Preventive Maintenance</Dropdown.Item>

						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/oem-maintenance">OEM Maintenance</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/maintenance-procedures">Maintenance Procedures</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/machine-ledgers">Machine Ledgers</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="troubleshooting-element">
						<MdSyncProblem size={'4vw'} />
						<p>Troubleshoot</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/fort-wayne/troubleshooting/troubleshoot-overview">Troubleshooting Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/troubleshooting/mechanical-troubleshooting">Mechanical Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/troubleshooting/electrical-troubleshooting">Electrical Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/troubleshooting/oem-troubleshooting">OEM Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/troubleshooting/smart-inspect-troubleshooting">SMARTInspect Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/troubleshooting/hardware-troubleshooting">Hardware Troubleshooting</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="drawing-element" href="/smart-inspect/fort-wayne/drawings">
						<BsPencil size={'4vw'} />
						<p>Drawings</p>
					</Dropdown.Toggle>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="appendix-element">
						<FaBookOpen size={'4vw'} />
						<p>Appendix</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/fort-wayne/appendix">Appendix</Dropdown.Item>
						<Dropdown.Item>Training Docs</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</ul>
		</nav>
	);
};
const SHNavbar = (props) => {
	return (
		<nav>
			<ul class="vert-nav">
				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="safety-element">
						<TbTrafficCone size={'4vw'} />
						<p>Safety</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/fort-wayne/safety/safety-overview">Safety Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/safety/control-safety">Control Safety</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/safety/safety-devices">Safety Devices</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/safety/equipment-lockout">Equipment Lockout</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/safety/energy-sources">Energy Sources</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="equipment-element">
						<FaClipboardList size={'4vw'} />
						<p>Equipment</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/fort-wayne/equipment/equipment-overview">Equipment Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/equipment/assemblies">Assemblies</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/equipment/electrical-panels">Electrical Panels</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/equipment/system-control">System Control</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/equipment/part-detect">Part / Skid Detect</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="maintenance-element">
						<VscTools size={'4vw'} />
						<p>Maintenance</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/maintenance-overview">Maintenance Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/maintenance-safety">Maintenance Safety</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/maintenance-lockout">Maintenance Lockout Procedure</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/preventive-maintenance">Preventive Maintenance</Dropdown.Item>

						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/oem-maintenance">OEM Maintenance</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/maintenance-procedures">Maintenance Procedures</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/maintenance/machine-ledgers">Machine Ledgers</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="troubleshooting-element">
						<MdSyncProblem size={'4vw'} />
						<p>Troubleshoot</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/fort-wayne/troubleshooting/troubleshoot-overview">Troubleshooting Overview</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/troubleshooting/mechanical-troubleshooting">Mechanical Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/troubleshooting/electrical-troubleshooting">Electrical Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/troubleshooting/oem-troubleshooting">OEM Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/troubleshooting/smart-inspect-troubleshooting">SMARTInspect Troubleshooting</Dropdown.Item>
						<Dropdown.Item href="/smart-inspect/fort-wayne/troubleshooting/hardware-troubleshooting">Hardware Troubleshooting</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="drawing-element" href="/smart-inspect/fort-wayne/drawings">
						<BsPencil size={'4vw'} />
						<p>Drawings</p>
					</Dropdown.Toggle>
				</Dropdown>

				<Dropdown drop={'end'}>
					<Dropdown.Toggle className="appendix-element">
						<FaBookOpen size={'4vw'} />
						<p>Appendix</p>
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item href="/smart-inspect/fort-wayne/appendix">Appendix</Dropdown.Item>
						<Dropdown.Item>Training Docs</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</ul>
		</nav>
	);
};

export { SFNavbar, SINavbar, MMANavbar, FWNavbar, SHNavbar };
